// Picture object produced by vite-imagetools with `?as=picture` query.
// Shape: { sources: { avif: string, webp: string, jpeg/png: string }, img: { src, w, h } }
export type Picture = {
  sources: Record<string, string>;
  img: { src: string; w: number; h: number };
};

export type HeroImageSource = string | Picture;

export function isPicture(value: HeroImageSource): value is Picture {
  return typeof value === "object" && value !== null && "img" in value && "sources" in value;
}
